module.exports = __webpack_public_path__ + "static/media/thin.45c65ab9.svg";